import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-community',
  templateUrl: './community.component.html',
  styleUrls: ['./community.component.css']
})
export class CommunityComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    private fb: FormBuilder,
  ) { }

  userProfile: string = 'Freelancer';

  newUserRegisterForm = this.fb.group({
    fullName: ['', Validators.required],
    userName: ['', Validators.required],
    fullEmail: ['', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"), Validators.required]],
    password: ['', Validators.required],
  });

  ngOnInit(): void {
    this.titleService.setTitle("Community | Workspace | Crafttor");
    this.metaTagService.addTags([
      { name: 'description', content: 'Crafttor Workspace community for a better product.'},
      { name: 'keywords', content: 'our mission, crafttor mission, workflow' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);
  }

  getUserProfile() {
    // if (this.letsTalkFormNew.valid) {
    //   this.reCaptchaV3Service.execute(this.siteKey, 'contact_us', (token) => {
    //     this.letsTalkFormNew.value['recaptcha'] = token;
    //
    //   });
    // }
  }

  selectUserProfile (event: any) {
    this.userProfile = event.target.value;
  }

  openMarketplace() {
    window.open("https://crafttor.com/marketplace", "_blank");
  }
}
